@if (!readonly || !!question.alternatives) {
  <div>
    @switch (question.type) {
      @case (type.Alternative) {
        <app-form-alternative [readonly]="readonly" [question]="question" [form]="form">
        </app-form-alternative>
      }
      @case (type.Email) {
        <div>
          <input [readonly]="readonly" [class.error]="question.isValid===false" [placeholder]="question.title" type="email"
            class="form-control" [name]="question.id" [id]="question.id" #control
            [value]="question.answer? question.answer : ''" (blur)="update(control.value)" />
            <app-collapsible [trigger]="question.isValid===false && !!question.answer">
              <p class="form-error">
                Please check that you have entered the email address correctly
              </p>
            </app-collapsible>
          </div>
        }
        @case (type.ShortText) {
          <input [readonly]="readonly" [class.error]="question.isValid===false"
            [placeholder]="question.title" type="text" class="form-control" [name]="question.id" [id]="question.id" #control
            [value]="question.answer? question.answer : ''" (blur)="update(control.value)" />
        }
        @case (type.LongText) {
          <input [readonly]="readonly" [class.error]="question.isValid===false"
            [placeholder]="question.title" type="text" class="form-control" [name]="question.id" [id]="question.id" #control
            [value]="question.answer? question.answer : ''" (blur)="update(control.value)" />
        }
        @case (type.FreeText) {
          <app-text-editor (contentChanged)="update($event)"
            (infoChanged)="onInfoChanged($event)" [error]="question.isValid===false" [content]="question.answer"
            [readonly]="readonly" [description]="question.title" [hasFocus]="hasFocus" [inputId]="question.id">
          </app-text-editor>
        }
        @case (type.Bool) {
          <input [readonly]="readonly" [class.error]="question.isValid===false" type="checkbox"
            class="form-control" [name]="question.id" [value]="question.answer" (change)="update(question.answer)" />
        }
        @case (type.Number) {
          <div>
            <div style="width: 100px;">
              <input [readonly]="readonly" [class.error]="question.isValid===false" type="text" class="form-control"
                [min]="question.min" [max]="question.max" [name]="question.id" [(ngModel)]="question.answer"
                [placeholder]="question.min + '-' + question.max" (blur)="update(question.answer)"
                (ngModelChange)="update(question.answer)" />
              </div>
            </div>
          }
          @case (type.Date) {
            <div>
              <app-utc-date-picker [readonly]="readonly" [name]="question.id" [min]="question.min" [max]="question.max"
                [error]="question.isValid===false" [(ngModel)]="question.answer" (ngModelChange)="update(question.answer)">
              </app-utc-date-picker>
            </div>
          }
        }
      </div>
      <app-collapsible [trigger]="$safeNavigationMigration(question.errors?.length)">
        @for (error of question?.errors; track error) {
          <p class="form-error">{{error}}</p>
        }
      </app-collapsible>
    } @else {
      <div class="form-control readonly" [innerHTML]="question.answer">
      </div>
      @if (question.referenceNumber) {
        <div >
          <div>Declaration reference number</div>
          <div  class="form-control readonly" [innerHTML]="question.referenceNumber"></div>
        </div>
      }
    }

